import { ISignalModule, ModuleType } from 'app/services/ostroAdapter';
import { useAimSignalStateStore } from 'app/stores/AimSignalStateStore';
import { useEffect, useRef } from 'react';

import { ConditionIdChangeEvent } from './types';
import { canUpdateConditionId } from './util';

const useAimSignalMonitor = () => {
  const signalModule = useRef<ISignalModule | undefined>(
    (window.ostro?.moduleManager?.modules?.find?.(
      ({ module_type }) => module_type === ModuleType.Signal
    ) as ISignalModule) ?? undefined
  );

  const aimSignalStateStore = useAimSignalStateStore();

  useEffect(() => {
    // Exit early if signalModule is not available
    if (!signalModule.current) return;

    const controller = new AbortController();

    signalModule.current.addEventListener(
      'aim:conditionId:update',
      ((event: ConditionIdChangeEvent) =>
        aimSignalStateStore.setNewConditionId(event.detail.conditionId)) as EventListener,
      { signal: controller.signal }
    );

    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Exit early if newConditionId is empty or window.TAIlor is undefined
    if (!window.TAIlor || !canUpdateConditionId(aimSignalStateStore)) {
      return;
    }

    window.TAIlor.reloadWithId(aimSignalStateStore.newConditionId!);
    aimSignalStateStore.setNewConditionId(null);
  }, [aimSignalStateStore]);
};

export default useAimSignalMonitor;
